import React from "react";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import "./Calculator.scss";

import Mortgage from "./Sections/Mortgage";
import StampDuty from "./Sections/StampDuty";

const Calculator = ({price, department}) => {

    var stamp_calcul_tab = process.env.GATSBY_STAMPDUTY_COUNTRY === "SCOTLAND" ? "LBTT Calculator" : "Stamp Duty Calculator";

    const eventCall = (event) => {
        //console.log("calculator_type", event.target.textContent)
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'calculator',
            'formType': event.target.textContent,
            'formName': event.target.textContent,
            'formLabel': event.target.textContent
        });
    }

    const openWin = (url) => { 
        typeof window !== "undefined" && window.open( url, "popup",  "width=500,height=600,left=400" ); 
    }
    
    return (
        <React.Fragment>
            <section className="calculator locarating-map">
                <div className="calculate">
                    <div className="h3">Property Calculators</div>
                    {process.env.GATSBY_SITE_NAME === "Linley and Simpson" ? 
                        <div className="more-info">
                            <div className="info-wrap">
                                <a href="javascript:;" onClick={() =>openWin("https://www.mortgageadvicebureau.com/introducer-forms-calculators/linley-simpson/repayment-calculator/")} className="icon-wrap">
                                    <i className="icons-calculator"></i>
                                    <span className="text">Repayment Calculator</span>
                                </a>
                                <a href="javascript:;" onClick={() =>openWin("https://www.mortgageadvicebureau.com/introducer-forms-calculators/linley-simpson/borrowing-power/")} className="icon-wrap">
                                    <i className="icons-calculator"></i>
                                    <span className="text">Borrowing Calculator</span>
                                </a>
                                <a href="javascript:;" onClick={() =>openWin("https://www.mortgageadvicebureau.com/introducer-forms-calculators/linley-simpson/stamp-duty/")} className="icon-wrap">
                                    <i className="icons-calculator"></i>
                                    <span className="text">Stamp Duty</span>
                                </a>
                                <a href="javascript:;" onClick={() =>openWin("https://home.app.mortgageadvicebureau.com/?introducercode=linley_simpson_digital_app&introducerupdate=true")} className="icon-wrap">
                                    <i className="icons-calculator"></i>
                                    <span className="text">Affordability</span>
                                </a>
                            </div>
                        </div>
                    :
                        <Tabs defaultActiveKey="mortgage">
                            <Tab eventKey="mortgage" title="Mortgage Calculator">
                                <Mortgage price={price}/>
                            </Tab>
                            <Tab eventKey="stamp_duty" title={stamp_calcul_tab}>
                                <StampDuty price={price} department={department} title={stamp_calcul_tab}/>
                            </Tab>
                        </Tabs>
                    }
                </div>

            </section>
        </React.Fragment>
    );
};
export default Calculator;
